import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { contact } from '../data/site';
export function FloatingWhatsApp() {
  const [hovered, setHovered] = useState(false);
  return <div className="fixed bottom-5 right-5 z-50 flex items-center gap-3 sm:bottom-7 sm:right-7" data-id="element-18" data-mp="1h0he2xr83e9">
      <AnimatePresence data-id="element-19" data-mp="3tksxcwh78zlf">
        {hovered && <motion.span initial={{
        opacity: 0,
        x: 8
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: 8
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="hidden rounded-full border border-navy/[0.07] bg-white px-4 py-2 text-[12.5px] font-medium text-navy shadow-soft sm:block" data-id="element-20" data-mp="3ojwumm8l3jhl">
            ¿Tienes preguntas? Escríbeme.
          </motion.span>}
      </AnimatePresence>
      <a href={contact.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Escríbeme por WhatsApp" title="¿Tienes preguntas? Escríbeme." onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onFocus={() => setHovered(true)} onBlur={() => setHovered(false)} className="flex h-14 w-14 items-center justify-center rounded-full bg-teal text-white shadow-lift transition-[background-color,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#365e63]" data-id="element-21" data-mp="30uaxe4brvec8">
        <MessageCircleIcon size={24} strokeWidth={1.6} data-id="element-22" data-mp="az6oi9g8pjbx" />
      </a>
    </div>;
}